export const commonTranslations = {
  ar: {
    save: 'حفظ',
    cancel: 'إلغاء',
    delete: 'حذف',
    edit: 'تعديل',
    add: 'إضافة',
    search: 'بحث',
    searchPlaceholder: 'بحث...',
    loading: 'جاري التحميل...',
    error: 'حدث خطأ',
    success: 'تم بنجاح',
    confirm: 'تأكيد',
    close: 'إغلاق',
    view: 'عرض',
    copy: 'نسخ',
    paste: 'لصق',
    clear: 'مسح',
    select: 'اختر',
    previous: 'السابق',
    next: 'التالي',
    page: 'صفحة',
    of: 'من',
    showing: 'عرض',
    to: 'إلى',
    results: 'نتيجة',
    noData: 'لا توجد بيانات',
    refresh: 'تحديث',
    filter: 'تصفية',
    export: 'تصدير',
    print: 'طباعة',
    actions: 'الإجراءات',
    yes: 'نعم',
    no: 'لا',
    required: 'مطلوب',
    optional: 'اختياري',
    name: 'الاسم',
    description: 'الوصف',
    date: 'التاريخ',
    status: 'الحالة',
    active: 'نشط',
    inactive: 'غير نشط',
    saveSuccess: 'تم الحفظ بنجاح',
    saveError: 'فشل الحفظ',
    deleteSuccess: 'تم الحذف بنجاح',
    deleteError: 'فشل الحذف',
    updateSuccess: 'تم التحديث بنجاح',
    updateError: 'فشل التحديث',
    confirmDelete: 'هل أنت متأكد من الحذف؟',
    saving: 'جاري الحفظ...',
    loadingData: 'جاري تحميل البيانات...',
    noResults: 'لا توجد نتائج',
    selectAll: 'تحديد الكل',
    deselectAll: 'إلغاء التحديد',
    all: 'الكل',
    company: 'الشركة',
    account: 'الحساب',
    costCenter: 'مركز التكلفة',
    debit: 'مدين',
    credit: 'دائن',
    notes: 'ملاحظات',
    dragDrop: 'أو اسحب الملف هنا',
    fromDate: 'من تاريخ',
    toDate: 'إلى تاريخ',
    branch: 'الفرع',
    customer: 'العميل',
    total: 'الإجمالي',
    back: 'رجوع',
    open: 'فتح',
    comingSoon: 'قريباً',
    net: 'الصافي',
    tax: 'الضريبة',
    fromAccount: 'الحساب المصدر',
    toAccount: 'الحساب الهدف',
    operations: 'العمليات',
    transfer: 'نقل',
    transferSuccess: 'تم النقل بنجاح',
    transferError: 'فشل النقل',
    selectSourceAccount: 'يرجى اختيار الحساب المصدر',
    selectTargetAccount: 'يرجى اختيار الحساب الهدف',
    selectBranch: 'يرجى اختيار الفرع',
    selectOperations: 'يرجى تحديد العمليات',
    sameAccount: 'لا يمكن نقل العمليات من نفس الحساب',
    address: 'العنوان',
    serial: 'التسلسل',
    accessDenied: 'تم رفض الوصول',
    noPermissionPage: 'ليس لديك صلاحية للوصول إلى هذه الصفحة.',
    noPermissionAction: 'ليس لديك صلاحية لتنفيذ هذا الإجراء.',
    checkingPermissions: 'جاري التحقق من الصلاحيات...',
    amountMustBeGreaterThanZero: 'المبلغ يجب أن يكون أكبر من صفر',
    discountCannotExceedAmount: 'الخصم لا يمكن أن يتجاوز المبلغ',
    cannotMoveParent: 'لا يمكن نقل أو حذف عنصر أب يحتوي على عناصر فرعية',
    cannotDeleteParent: 'لا يمكن حذف عنصر يحتوي على عناصر فرعية. يجب حذف أو نقل العناصر الفرعية أولاً',
    moveSuccess: 'تم النقل بنجاح',
    moveError: 'فشل النقل',
    expand: 'توسيع',
    collapse: 'طي',
    childCenters: 'مراكز فرعية',
    centers: 'مراكز',
    changeLog: 'سجل التغييرات',
    selectPaymentMethod: 'اختر طريقة الدفع',
    noPaymentMethods: 'لا توجد طرق دفع',
    noInternet: '⚠️ لا يوجد اتصال بالإنترنت',
    offlineWorking: 'أنت تعمل في وضع عدم الاتصال. سيتم حفظ الفواتير محلياً.',
    pendingInvoices: 'فاتورة معلقة',
    connectionRestored: '✅ تم استعادة الاتصال',
    syncingAutomatically: 'سيتم مزامنة الفواتير المحفوظة تلقائياً',
    livePreview: 'معاينة مباشرة',
    startTypingToSeePreview: 'ابدأ بكتابة القالب لرؤية المعاينة',
    defaultTemplate: 'قالب افتراضي',
  },
  en: {
    save: 'Save',
    cancel: 'Cancel',
    delete: 'Delete',
    edit: 'Edit',
    add: 'Add',
    search: 'Search',
    searchPlaceholder: 'Search...',
    loading: 'Loading...',
    error: 'An error occurred',
    success: 'Success',
    confirm: 'Confirm',
    close: 'Close',
    view: 'View',
    copy: 'Copy',
    paste: 'Paste',
    clear: 'Clear',
    select: 'Select',
    previous: 'Previous',
    next: 'Next',
    page: 'Page',
    of: 'of',
    showing: 'Showing',
    to: 'to',
    results: 'results',
    noData: 'No data',
    refresh: 'Refresh',
    filter: 'Filter',
    export: 'Export',
    print: 'Print',
    actions: 'Actions',
    yes: 'Yes',
    no: 'No',
    required: 'Required',
    optional: 'Optional',
    name: 'Name',
    description: 'Description',
    date: 'Date',
    status: 'Status',
    active: 'Active',
    inactive: 'Inactive',
    saveSuccess: 'Saved successfully',
    saveError: 'Save failed',
    deleteSuccess: 'Deleted successfully',
    deleteError: 'Delete failed',
    updateSuccess: 'Updated successfully',
    updateError: 'Update failed',
    confirmDelete: 'Are you sure you want to delete?',
    saving: 'Saving...',
    loadingData: 'Loading data...',
    noResults: 'No results',
    selectAll: 'Select All',
    deselectAll: 'Deselect All',
    all: 'All',
    company: 'Company',
    account: 'Account',
    costCenter: 'Cost Center',
    debit: 'Debit',
    credit: 'Credit',
    notes: 'Notes',
    dragDrop: 'or drag and drop file here',
    fromDate: 'From Date',
    toDate: 'To Date',
    branch: 'Branch',
    customer: 'Customer',
    total: 'Total',
    back: 'Back',
    open: 'Open',
    comingSoon: 'Coming Soon',
    net: 'Net',
    tax: 'Tax',
    fromAccount: 'Source Account',
    toAccount: 'Target Account',
    operations: 'Operations',
    transfer: 'Transfer',
    transferSuccess: 'Transfer successful',
    transferError: 'Transfer failed',
    selectSourceAccount: 'Please select source account',
    selectTargetAccount: 'Please select target account',
    selectBranch: 'Please select branch',
    selectOperations: 'Please select operations',
    sameAccount: 'Cannot transfer operations within the same account',
    address: 'Address',
    serial: 'Serial',
    accessDenied: 'Access Denied',
    noPermissionPage: 'You do not have permission to access this page.',
    noPermissionAction: 'You do not have permission to perform this action.',
    checkingPermissions: 'Checking permissions...',
    amountMustBeGreaterThanZero: 'Amount must be greater than zero',
    discountCannotExceedAmount: 'Discount cannot exceed amount',
    cannotMoveParent: 'Cannot move or delete parent element with children',
    cannotDeleteParent: 'Cannot delete element with children. Must delete or move children first',
    moveSuccess: 'Move successful',
    moveError: 'Move failed',
    expand: 'Expand',
    collapse: 'Collapse',
    childCenters: 'Child Centers',
    centers: 'Centers',
    changeLog: 'Change Log',
    selectPaymentMethod: 'Select Payment Method',
    noPaymentMethods: 'No payment methods',
    noInternet: '⚠️ No Internet Connection',
    offlineWorking: "You're working offline. Invoices will be saved locally.",
    pendingInvoices: 'pending',
    connectionRestored: '✅ Connection Restored',
    syncingAutomatically: 'Pending invoices will be synced automatically',
    livePreview: 'Live Preview',
    startTypingToSeePreview: 'Start typing to see preview',
    defaultTemplate: 'Default template',
  },
  fr: {
    save: 'Enregistrer',
    cancel: 'Annuler',
    delete: 'Supprimer',
    edit: 'Modifier',
    add: 'Ajouter',
    search: 'Rechercher',
    searchPlaceholder: 'Rechercher...',
    loading: 'Chargement...',
    error: 'Une erreur s\'est produite',
    success: 'Succès',
    confirm: 'Confirmer',
    close: 'Fermer',
    view: 'Voir',
    copy: 'Copier',
    paste: 'Coller',
    clear: 'Effacer',
    select: 'Sélectionner',
    previous: 'Précédent',
    next: 'Suivant',
    page: 'Page',
    of: 'de',
    showing: 'Affichage',
    to: 'à',
    results: 'résultats',
    noData: 'Aucune donnée',
    refresh: 'Actualiser',
    filter: 'Filtrer',
    export: 'Exporter',
    print: 'Imprimer',
    actions: 'Actions',
    yes: 'Oui',
    no: 'Non',
    required: 'Requis',
    optional: 'Optionnel',
    name: 'Nom',
    description: 'Description',
    date: 'Date',
    status: 'Statut',
    active: 'Actif',
    inactive: 'Inactif',
    saveSuccess: 'Enregistré avec succès',
    saveError: 'Échec de l\'enregistrement',
    deleteSuccess: 'Supprimé avec succès',
    deleteError: 'Échec de la suppression',
    updateSuccess: 'Mis à jour avec succès',
    updateError: 'Échec de la mise à jour',
    confirmDelete: 'Êtes-vous sûr de vouloir supprimer?',
    saving: 'Enregistrement...',
    loadingData: 'Chargement des données...',
    noResults: 'Aucun résultat',
    selectAll: 'Tout sélectionner',
    deselectAll: 'Tout désélectionner',
    all: 'Tout',
    company: 'Entreprise',
    account: 'Compte',
    costCenter: 'Centre de coût',
    debit: 'Débit',
    credit: 'Crédit',
    notes: 'Notes',
    dragDrop: 'Ou glissez-déposez le fichier ici',
    fromDate: 'Date de début',
    toDate: 'Date de fin',
    branch: 'Succursale',
    customer: 'Client',
    total: 'Total',
    back: 'Retour',
    open: 'Ouvrir',
    comingSoon: 'Bientôt disponible',
    net: 'Net',
    tax: 'Taxe',
    fromAccount: 'Compte source',
    toAccount: 'Compte cible',
    operations: 'Opérations',
    transfer: 'Transférer',
    transferSuccess: 'Transféré avec succès',
    transferError: 'Échec du transfert',
    selectSourceAccount: 'Veuillez sélectionner le compte source',
    selectTargetAccount: 'Veuillez sélectionner le compte cible',
    selectBranch: 'Veuillez sélectionner la succursale',
    selectOperations: 'Veuillez sélectionner les opérations',
    sameAccount: 'Impossible de transférer des opérations depuis le même compte',
    address: 'Adresse',
    serial: 'Série',
    accessDenied: 'Accès refusé',
    noPermissionPage: "Vous n'avez pas la permission d'accéder à cette page.",
    noPermissionAction: "Vous n'avez pas la permission d'effectuer cette action.",
    checkingPermissions: 'Vérification des permissions...',
    amountMustBeGreaterThanZero: 'Le montant doit être supérieur à zéro',
    discountCannotExceedAmount: 'La remise ne peut pas dépasser le montant',
    cannotMoveParent: 'Impossible de déplacer یا supprimer un élément parent ayant des enfants',
    cannotDeleteParent: 'Impossible de supprimer un élément ayant des enfants. Veuillez d\'abord supprimer ou déplacer les enfants',
    moveSuccess: 'Déplacé avec succès',
    moveError: 'Échec du déplacement',
    expand: 'Développer',
    collapse: 'Réduire',
    childCenters: 'Centres enfants',
    centers: 'Centres',
    changeLog: 'Journal des modifications',
  },
}

